import { styled } from '../jss-style';
import modalStyle from './modal';

const useModalStyle = styled(modalStyle, 'modal');
export { modalStyle, useModalStyle };
export default useModalStyle;
